import React, {useState} from 'react';
import {office} from "../../../models/office";
import {scrollTo} from "../../../service/ToolsService";
import {NavLink} from "react-router-dom";
import {TableLineLoader} from "../../front/loader/TableLineLoader";
import DateService from "../../../service/DateService";
import {DeleteConfirme} from "../DeleteConfirme";
import {ApiService} from "../../../service/ApiService";

type OfficeListProps = {
  offices: office[],
  loading?: boolean,
  refresh: () => void
}

export const OfficeList = ({offices, loading, refresh}: OfficeListProps) => {
  const [del, setDel] = useState(undefined as undefined | office);

  const deleteUser = async (office: office) => {
    await ApiService.delete(`/office/${office.officeId}`);
    refresh();
  };

  return (
    <>
      <table className="table table-responsive table-hover border">
        <thead>
        <tr className="table-primary">
          <th>Nom</th>
          <th className="text-center w100px">Actif</th>
          <th className="text-center w100px">
            Poste
            <div className="ms-1 tooltip-container">
              <i className="fa-solid fa-circle-info" />
              <span className="tooltip-text bg-info text-light">renseigné / total</span>
            </div>
          </th>
          <th className="text-center w150px">Modification</th>
          <th className="w200px"></th>
        </tr>
        </thead>
        <tbody>
        {loading && (
          <tr>
            <td colSpan={5} className="pt-4 pb-4 ps-5 pe-5">
              <TableLineLoader/>
            </td>
          </tr>
        )}

        {!loading && offices.map((office: office, i: number) => (
          <tr key={i} className={office.enabled ? 'table-success' : ''}>
            <td>{office.label}</td>
            <td className="text-center">{office.enabled && (<i className="fa-solid fa-eye"/>)}</td>
            <td className="text-center">
              {office.post.filter(p => p.memberId !== undefined).length}
              &nbsp;/&nbsp;
              {office.post.length}
            </td>
            <td className="text-center">
              {DateService
                .toLocaleString(office.updatedAt ?? office.createdAt, {day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false})
              }
            </td>
            <td className="text-end">
              <NavLink to={`/admin/office/office/edit/${office.officeId}`} onClick={scrollTo} className="btn btn-xs btn-primary me-1">
                <i className="fa-solid fa-pencil me-1"/> modifier
              </NavLink>
              <button className="btn btn-xs btn-danger" onClick={() => setDel(office)}><i className="fa-solid fa-xmark me-1"/>supprimer</button>
            </td>
          </tr>
        ))}
        </tbody>
      </table>

      {del && (
        <DeleteConfirme confirme={(c: boolean) => {
          if (c) {
            deleteUser(del);
          }

          setDel(undefined);
        }}/>
      )}
    </>
  )
}
